import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const webhookSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  name: z.string().nullable().optional(),
  url: z.string().url(),
  events: z.array(z.string()),
  is_active: z.boolean(),
  headers: z.record(z.string()).default({}),
  timeout_ms: z.number().int().min(1000).max(60000).default(30000),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Webhook = z.infer<typeof webhookSchema>;

export const createWebhookSchema = z.object({
  name: z.string().max(200).optional(),
  url: z.string().url(),
  events: z.array(z.string()).min(1),
  headers: z.record(z.string()).optional(),
  timeout_ms: z.number().int().min(1000).max(60000).optional(),
});

export const updateWebhookSchema = createWebhookSchema.partial().extend({
  is_active: z.boolean().optional(),
});

export const webhookDeliverySchema = z.object({
  id: idSchema,
  webhook_id: idSchema,
  event_type: z.string(),
  delivery_id: idSchema,
  status: z.enum(['pending', 'success', 'failed', 'dead_letter']),
  attempt_count: z.number().int(),
  next_attempt_at: isoDateSchema,
  last_attempt_at: isoDateSchema.nullable().optional(),
  last_response_status: z.number().int().nullable().optional(),
  last_response_snippet: z.string().nullable().optional(),
  last_error: z.string().nullable().optional(),
  delivered_at: isoDateSchema.nullable().optional(),
  payload: jsonMetaSchema,
  created_at: isoDateSchema,
});
export type WebhookDelivery = z.infer<typeof webhookDeliverySchema>;
